import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    // Parent form element id to write hidden fields into (optional; when absent, dispatches playables:selected)
    formId: String,
  }

  connect() {
    if (this.hasFormIdValue && this.formIdValue) {
      this.ownerForm = document.getElementById(this.formIdValue)
    } else {
      this.ownerForm = null
    }
  }

  selectRadio(event) {
    const assetId = event.currentTarget?.dataset?.assetId
    if (!assetId) return
    const duration = event.currentTarget?.dataset?.duration || ""
    const assetType = event.currentTarget?.dataset?.assetType || ""

    const radio =
      this.element.querySelector(`#radio_asset_${assetId}`) ||
      document.getElementById(`radio_asset_${assetId}`)

    if (radio) radio.checked = true

    // Highlight selection in the playables grid
    const allCards = this.element.querySelectorAll(".asset-card")
    allCards.forEach((el) => el.classList.remove("outline"))

    const assetContainer =
      this.element.querySelector(`#asset_${assetId}`) ||
      document.getElementById(`asset_${assetId}`)

    const card = assetContainer?.querySelector(".asset-card")
    if (card) card.classList.add("outline")

    if (this.ownerForm) {
      const playableType = this.getPlayableType(event)
      this.upsertHiddenInputOnForm(this.ownerForm, "playable_id", assetId)
      this.upsertHiddenInputOnForm(this.ownerForm, "playable_type", playableType)
      this.upsertHiddenInputOnForm(this.ownerForm, "duration", duration)
    } else {
      this.element.dispatchEvent(
        new CustomEvent("playables:selected", {
          bubbles: true,
          detail: { duration, assetType },
        })
      )
    }
  }

  getPlayableType(event) {
    const assetType = event.currentTarget?.dataset?.assetType
    if (assetType === "image") return "Ads::Image"
    if (assetType === "video") return "Ads::Video"
    if (assetType === "loop") return "Loop"

    return ""
  }

  upsertHiddenInputOnForm(form, name, value) {
    if (!form) return

    let input = form.querySelector(`input[name="${name}"]`)
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      form.appendChild(input)
    }
    input.value = value
  }
}
